// Prosty wykres liniowy w SVG renderowany na serwerze (bez biblioteki wykresów); dostępny jako obraz z opisem i tabelą.
const WIDTH = 900
const HEIGHT = 320
const PAD = { top: 20, right: 20, bottom: 40, left: 44 }

export default function LineChart({ points, title, formatMonth }) {
  const max = Math.max(1, ...points.map((point) => point.count))
  const innerWidth = WIDTH - PAD.left - PAD.right
  const innerHeight = HEIGHT - PAD.top - PAD.bottom
  const x = (index) => PAD.left + (points.length > 1 ? (index / (points.length - 1)) * innerWidth : innerWidth / 2)
  const y = (count) => PAD.top + innerHeight - (count / max) * innerHeight
  const path = points.map((point, index) => `${index === 0 ? 'M' : 'L'}${x(index)},${y(point.count)}`).join(' ')
  const ticks = [0, 0.5, 1].map((fraction) => Math.round(max * fraction))
  const labelEvery = Math.max(1, Math.ceil(points.length / 12))

  return (
    <figure className="m-0">
      <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`} role="img" aria-label={title} style={{ width: '100%', height: 'auto' }}>
        <title>{title}</title>
        {ticks.map((tick) => (
          <g key={tick}>
            <line x1={PAD.left} x2={WIDTH - PAD.right} y1={y(tick)} y2={y(tick)} stroke="#d9d9d9" />
            <text x={PAD.left - 8} y={y(tick) + 4} fontSize="12" textAnchor="end">
              {tick}
            </text>
          </g>
        ))}
        <path d={path} fill="none" stroke="#476ecc" strokeWidth="2" />
        {points.map((point, index) => (
          <g key={point.month}>
            <circle cx={x(index)} cy={y(point.count)} r="3" fill="#476ecc" />
            {index % labelEvery === 0 && (
              <text x={x(index)} y={HEIGHT - 14} fontSize="11" textAnchor="middle">
                {formatMonth(point.month)}
              </text>
            )}
          </g>
        ))}
      </svg>
    </figure>
  )
}
